// Kitchen Display (KDS) shared configuration.
// Single source of truth for order-age urgency thresholds — keep OrderCard
// and TimerDisplay in sync by importing getUrgency() instead of hardcoding.

// An order is "warning" once it has been open this many minutes...
export const URGENCY_WARNING_MIN = 10;
// ...and "urgent" past this many minutes.
export const URGENCY_URGENT_MIN = 20;

// How long (ms) a freshly-arrived order keeps its "new" highlight.
export const NEW_ORDER_HIGHLIGHT_MS = 10000;

/**
 * Classify an order by how long it has been open.
 * @param {number} ageMinutes - minutes since the order was placed
 * @returns {'normal' | 'warning' | 'urgent'}
 */
export const getUrgency = (ageMinutes) => {
  if (ageMinutes < URGENCY_WARNING_MIN) return 'normal';
  if (ageMinutes < URGENCY_URGENT_MIN) return 'warning';
  return 'urgent';
};
